import { BrowserRouter, Route, Routes } from "react-router-dom";
import "@/App.css";
import { Layout } from "@/components/layout/Layout";
import Home from "@/pages/Home";
import StubPage from "@/pages/StubPage";
import ServicePage from "@/pages/ServicePage";
import ServicesHub from "@/pages/ServicesHub";
import AreasIndex from "@/pages/AreasIndex";
import AreaPage from "@/pages/AreaPage";
import About from "@/pages/About";
import Gallery from "@/pages/Gallery";
import Reviews from "@/pages/Reviews";
import AdviceIndex from "@/pages/AdviceIndex";
import GuidePage from "@/pages/GuidePage";
import Contact from "@/pages/Contact";
import { SERVICE_PAGES } from "@/content/services";
import { AREA_PAGES } from "@/content/areas";
import { GUIDES } from "@/content/advice";
import AdminApp from "@/admin/AdminApp";

const NOT_FOUND = {
  title: "Page Not Found",
  h1: "Page Not Found",
  intro: "That page does not exist. Try our services, areas we cover, or get in touch for a free quote.",
};

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/admin/*" element={<AdminApp />} />
        <Route element={<Layout />}>
          <Route index element={<Home />} />

          <Route path="/services" element={<ServicesHub />} />
          {SERVICE_PAGES.map((s) => (
            <Route key={s.path} path={s.path} element={<ServicePage service={s} />} />
          ))}

          <Route path="/areas" element={<AreasIndex />} />
          {AREA_PAGES.map((a) => (
            <Route key={a.path} path={a.path} element={<AreaPage area={a} />} />
          ))}

          <Route path="/about" element={<About />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/reviews" element={<Reviews />} />

          <Route path="/advice" element={<AdviceIndex />} />
          {GUIDES.map((g) => (
            <Route key={g.path} path={g.path} element={<GuidePage guide={g} />} />
          ))}

          <Route path="/contact" element={<Contact />} />

          <Route path="*" element={<StubPage page={NOT_FOUND} />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
